export * from "./clientConfigs"
export * from "./hooks"
export * from "./utils"
export * from "./regex"

// "./routes"는 의도적으로 재export하지 않는다. routes.ts가 최상위에서 13MB 규모의
// 경로 JSON을 즉시 spread하므로 tree-shaking이 불가능하고, 배럴에 포함되면
// @today/lib를 import하는 모든 클라이언트 번들에 해당 데이터가 실린다.
// 필요한 곳에서 "@today/lib/routes"를 직접 import할 것.
